import { AxiosResponse } from 'axios';

export const errorHandler = (error: AxiosResponse | Error | any): string | Error => {
	if (error?.data?.errorMessage || error?.data?.title) {
		return error.data.errorMessage;
	}
	return error;
};
